import StatementUseCasesInterface from "./statementInterface";
import statement_repository from "../../../../infrastructure/repository/impl/statement/statement_repository";
import { Statement } from "../../../entities/statement";
import { Order } from "../../../entities/order";
import { ListResponse } from "../../../entities/shop/product/listResponse";

class StatementUseCases implements StatementUseCasesInterface {
  async list(order: Order): Promise<ListResponse<Statement[]>> {
    return await statement_repository.list(order);
  }
}

export default new StatementUseCases() as StatementUseCasesInterface;
